(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystiboo-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mystiboo-sparkle-field]').forEach((field) => {
    if (field.dataset.mystibooSparkled) return;
    field.dataset.mystibooSparkled = 'true';
    const glyphs = ['✦', '✧', '⋆', '・', '♡'];
    for (let i = 0; i < 20; i++) {
      const s = document.createElement('span');
      s.textContent = glyphs[Math.floor(Math.random() * glyphs.length)];
      s.style.left = Math.random() * 100 + '%';
      s.style.top = Math.random() * 100 + '%';
      s.style.animationDelay = Math.random() * 6 + 's';
      s.style.color = Math.random() > 0.5 ? '#F2528C' : '#DECBFA';
      field.appendChild(s);
    }
  });

  function mystibooBurstConfetti(stage) {
    const glyphs = ['✨', '💗', '⭐', '🎀', '💫'];
    for (let i = 0; i < 10; i++) {
      const c = document.createElement('span');
      c.className = 'mystiboo-hero__confetti';
      c.textContent = glyphs[Math.floor(Math.random() * glyphs.length)];
      const angle = Math.random() * Math.PI - Math.PI / 2 - Math.PI / 2;
      const dist = 60 + Math.random() * 70;
      c.style.left = '50%';
      c.style.top = '30%';
      c.style.transition = 'transform 0.9s cubic-bezier(.2,.8,.2,1), opacity 0.9s ease';
      stage.appendChild(c);
      requestAnimationFrame(() => {
        c.style.opacity = '1';
        const dx = Math.cos(angle) * dist;
        const dy = Math.sin(angle) * dist - 40;
        c.style.transform = `translate(${dx}px, ${dy}px) rotate(${Math.random() * 360}deg)`;
      });
      setTimeout(() => { c.style.opacity = '0'; }, 650);
      setTimeout(() => { c.remove(); }, 950);
    }
  }

  document.querySelectorAll('[data-mystiboo-box]').forEach((box) => {
    if (box.dataset.mystibooBound) return;
    box.dataset.mystibooBound = 'true';

    const stage = box.closest('.mystiboo-hero__box-stage');
    const caption = stage ? stage.querySelector('[data-mystiboo-caption]') : null;

    const toggle = () => {
      const opened = box.classList.toggle('is-opened');
      box.setAttribute('aria-pressed', String(opened));
      if (caption) {
        caption.textContent = opened
          ? "6 items inside — this one hit the rare drop! ✨"
          : 'click to open ♡';
      }
      if (opened && stage) mystibooBurstConfetti(stage);
    };

    box.addEventListener('click', toggle);
    box.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystiboo-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mystiboo-reviews]').forEach((root) => {
    if (root.dataset.mystibooReviewsBound) return;
    root.dataset.mystibooReviewsBound = 'true';

    const widget = root.querySelector('.jdgm-all-reviews-widget');
    const widgetWrap = root.querySelector('.mystiboo-reviews__widget-wrap');
    const empty = root.querySelector('[data-mystiboo-reviews-empty]');
    if (!widget || !widgetWrap || !empty) return;

    const reveal = () => {
      const hasContent = widget.childElementCount > 0;
      widgetWrap.hidden = !hasContent;
      empty.hidden = hasContent;
    };

    reveal();
    new MutationObserver(reveal).observe(widget, { childList: true });
  });

  } catch(e) { console.error(e); }
})();
})();
